import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';

import { bdsGridModeType } from '@bds/components';

import { CommunicationMessage, CommunicationService } from '@bds/core';
import { FastracDxGridWrapperComponent, FastracScreenBaseComponent } from '@bds/fastrac';
import { CarIdTransformService } from '@bds/helpers';

import { FastracColsService } from '@bds/services';

import { RtAutoCarAssignService } from '@bds/railtrac';

import { faBars } from '@fortawesome/pro-solid-svg-icons';
import DataSource from 'devextreme/data/data_source';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { PageService } from '@bds/core';
import { ErrorListItem } from '@bds/rt-advance-models';
import { BdsDialogMultiConfirmComponent, BdsDialogMultiConfirmModel } from '@bds/smart-components';
import { RtAutoCarAssignDetailsDialogComponent } from '@bds/railtrac';

@Component({
    selector: 'app-auto-car-assign-screen',
    templateUrl: './auto-car-assign-screen.component.html',
    styleUrl: './auto-car-assign-screen.component.scss',
    encapsulation: ViewEncapsulation.None,
})
export class AutoCarAssignScreenComponent
    extends FastracScreenBaseComponent
    implements OnInit, OnDestroy
{
    @ViewChild('dxGridWrapper') fastracGridComponent: FastracDxGridWrapperComponent;

    public gridSource: DataSource;
    public allowModeToggle = true;
    public selectedRowKeys: number[] = [];
    public selectedRowData: any[] = [];
    public gridId = 142;
    public gridMode: bdsGridModeType = 'multiple';

    public iconMenu = faBars;

    isDirty = false;
    errors: ErrorListItem[] = [];

    private ngUnsubscribe$: Subject<boolean> = new Subject<boolean>();

    get grid() {
        return this.fastracGridComponent?.grid;
    }

    constructor(
        public autoCarAssignService: RtAutoCarAssignService,
        public dialog: MatDialog,
        public router: Router,
        public route: ActivatedRoute,
        pageService: PageService,
        public snackbar: MatSnackBar,
        public gridColumnService: FastracColsService,
        public carIdTransformService: CarIdTransformService,
        public communicationService: CommunicationService,
    ) {
        super(router, route, gridColumnService, communicationService, carIdTransformService);

        pageService.setHeader('Auto Car Assign');

        communicationService
            .getData()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((m) => {
                const message: CommunicationMessage = m as CommunicationMessage;
                if (message && message.subscriberName === 'AutoCarAssignScreen' && message.data) {
                    if (this.grid && this.grid.instance) {
                        void this.grid.instance.refresh();
                    }
                }
            });

        // TODO: Replace with actual AutoCarAssign service call
        this.gridSource = this.autoCarAssignService.getODataStore();
    }

    ngOnInit() {
        super.ngOnInit();
        this.grid?.instance.repaint();
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
        this.ngUnsubscribe$.next(true);
        this.ngUnsubscribe$.unsubscribe();
    }

    refreshGrid(): void {
        void this.grid.instance.refresh();
    }

    createRecord(): void {
        const dialogRef = this.dialog.open(RtAutoCarAssignDetailsDialogComponent, {
            width: '800px',
            data: {
                title: 'Add Auto Car Assign',
            },
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                void this.grid.instance.refresh();
            }
        });
    }

    deleteRecords(): void {
        this.selectedRowData = this.grid.instance.getSelectedRowsData();
        if (this.selectedRowData == null || this.selectedRowData.length === 0) {
            return;
        }

        const confirmInfo: BdsDialogMultiConfirmModel = {
            title: 'Delete Confirmation',
            content: `Are you sure you want to delete ${this.selectedRowKeys.length} record(s)?`,
            actionText: 'Delete',
        };

        const dialogRef = this.dialog.open(BdsDialogMultiConfirmComponent, {
            data: confirmInfo,
        });

        dialogRef.beforeClosed().subscribe((result) => {
            if (result) {
                const ormIds = this.selectedRowData.map((row) => row.ormId);
                this.autoCarAssignService.deleteRecords(ormIds).subscribe({
                    next: () => {
                        this.snackbar.open('Record(s) deleted successfully!', 'Ok', {
                            duration: 3000,
                        });
                        void this.grid.instance.refresh();
                    },
                    error: () => {
                        this.snackbar.open('Error deleting record(s).', 'Error', {
                            duration: 3000,
                            panelClass: 'error-snack',
                        });
                    },
                });
            }
        });
    }

    onGridFastracIdChanged($event: number): void {
        super.onGridFastracIdChanged($event);
        void this.grid.instance.refresh();
    }
}
